import React, { useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import {
  BiChevronLeft,
  BiChevronRight,
  BiLeftArrowAlt,
  BiRightArrowAlt,
} from "react-icons/bi";
import { GoDotFill } from "react-icons/go";
import styles from "./calendar.module.css";
import { Col, Popover, Row, Typography } from "antd";
import moment from "moment/moment";
import { TextComponent } from "../../../../../components";

const localizer = momentLocalizer(moment);

function RBCToolbar(props) {
  const { label, date, view, views, onView, onNavigate } = props;
  const [month, setMonth] = useState("January");
  const mMonth = moment(date).format("MMM");
  const months = moment.months();

  useEffect(() => {
    setMonth(mMonth);
  }, [mMonth]);

  const onChange = (event) => {
    const current = event.target.value;
    onNavigate("DATE", moment().month(current).toDate());
    setMonth(current);
  };

  const goToView = (view) => {
    onView(view);
  };

  const goToBack = () => {
    onNavigate("PREV");
  };
  const goToNext = () => {
    onNavigate("NEXT");
  };

  const goToToday = () => {
    onNavigate("TODAY");
  };

  return (
    <>
      <Row className={styles.rowCont}>
        <TextComponent
          text={"Availability Schedule"}
          textClass={styles.calHeading}
        />
      </Row>
      <Row className={styles.rowCont}>
        <TextComponent
          text={`${moment(date).add("months").format("MMM")} ${moment(
            date
          ).format("YYYY")} `}
          textClass={styles.calHeading}
          style={{ width: "100px" }}
        />
        <BiChevronLeft
          size={30}
          className={styles.iconArrow}
          onClick={goToBack}
        />
        <BiChevronRight
          size={30}
          className={styles.iconArrow}
          onClick={goToNext}
        />
      </Row>
      <Row className={styles.rowCont} style={{ marginBottom: "20px" }}>
        <GoDotFill size={20} className={styles.icon} color="#81FF6C" />
        <TextComponent text={"Working"} textClass={styles.textClass} />
        <GoDotFill size={20} className={styles.icon} color="#EF62BD" />
        <TextComponent text={"Available"} textClass={styles.textClass} />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <GoDotFill size={20} className={styles.icon} color="#D6D6D6" />
          <TextComponent text={"Not Available"} textClass={styles.textClass} />
        </div>
      </Row>
    </>
  );
}

function Event(event) {
  return (
    <>
      <div className={styles.eventCont}>
        <div className={styles.activeDate} />
      </div>
    </>
  );
}

function CalendarComp() {
  const [data, setData] = useState([1]);
  const eventsData = data?.map((data) => {
    // let startDate = data.date
    return {
      itemData: data,
      title: data?.details,
      start: new Date(new Date().setDate(new Date().getDate() - 5)),
      end: new Date(new Date().setDate(new Date().getDate() - 5)),
      color: "red",
    };
  });
  return (
    <Calendar
      step={30}
      //   toolbar={true}
      selectable
      onNavigate={(props)=>{
        console.log(props);
      }}
      style={{
        width: "100%",
        height: 450,
        marginBottom: "20px",
        color: "black",
        backgroundColor: "transparent",
        fontFamily: "var(--font-family)",
      }}
      tooltipAccessor={true}
      localizer={localizer}
      events={eventsData}
      //   step={60}
      components={{
        toolbar: RBCToolbar,
        dateCellWrapper: (props) => (
          <div className={styles.dayCell}>{props.children}</div>
        ),
        event: Event,
        resourceHeader: (props) => (
          <div className={styles.dayCell} style={{ border: 0 }}></div>
        ),
      }}
      views={{
        month: true,
        week: false,
      }}
      eventPropGetter={(eventsData) => {
        return { style: { backgroundColor: "transparent", outline: 0 } };
      }}
    />
  );
}

export default CalendarComp;
